import { render, staticRenderFns } from "./RegistrationSuccessful.vue?vue&type=template&id=5db2f8ae&scoped=true&"
import script from "./RegistrationSuccessful.vue?vue&type=script&lang=js&"
export * from "./RegistrationSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSuccessful.vue?vue&type=style&index=0&id=5db2f8ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2f8ae",
  null
  
)

export default component.exports